import styled from 'styled-components'

export const H2 = styled.h2``
